// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/AccountModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { CreditAccountInfo } from "./CreditModels";
import { Dapp } from "./DappModels";
import { StorageLimits } from "./DriveModels";
import { Host } from "./HostModels";
import { PagingInfo } from "./SystemModels";

export const protobufPackage = "daisi.protos.v1";

export enum UserRoles {
  UserRolesReader = 0,
  UserRolesManager = 1,
  UserRolesOwner = 2,
  UserRolesAdmin = 3,
  UNRECOGNIZED = -1,
}

export function userRolesFromJSON(object: any): UserRoles {
  switch (object) {
    case 0:
    case "UserRolesReader":
      return UserRoles.UserRolesReader;
    case 1:
    case "UserRolesManager":
      return UserRoles.UserRolesManager;
    case 2:
    case "UserRolesOwner":
      return UserRoles.UserRolesOwner;
    case 3:
    case "UserRolesAdmin":
      return UserRoles.UserRolesAdmin;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserRoles.UNRECOGNIZED;
  }
}

export function userRolesToJSON(object: UserRoles): string {
  switch (object) {
    case UserRoles.UserRolesReader:
      return "UserRolesReader";
    case UserRoles.UserRolesManager:
      return "UserRolesManager";
    case UserRoles.UserRolesOwner:
      return "UserRolesOwner";
    case UserRoles.UserRolesAdmin:
      return "UserRolesAdmin";
    case UserRoles.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum UserStatus {
  UserStatusActive = 0,
  UserStatusArchived = 1,
  UNRECOGNIZED = -1,
}

export function userStatusFromJSON(object: any): UserStatus {
  switch (object) {
    case 0:
    case "UserStatusActive":
      return UserStatus.UserStatusActive;
    case 1:
    case "UserStatusArchived":
      return UserStatus.UserStatusArchived;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserStatus.UNRECOGNIZED;
  }
}

export function userStatusToJSON(object: UserStatus): string {
  switch (object) {
    case UserStatus.UserStatusActive:
      return "UserStatusActive";
    case UserStatus.UserStatusArchived:
      return "UserStatusArchived";
    case UserStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetAccountRequest {
}

export interface GetAccountResponse {
  Account?: Account | undefined;
  HasTaxId: boolean;
}

export interface UpdateAccountRequest {
  Account?: Account | undefined;
}

export interface UpdateAccountResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface CreateUserRequest {
  User?: User | undefined;
  AccountName?: string | undefined;
}

export interface CreateUserResponse {
  Success: boolean;
  User?: User | undefined;
  Message?: string | undefined;
}

export interface GetUserRequest {
  UserId: string;
}

export interface GetUserResponse {
  User?: User | undefined;
  Success: boolean;
  Message?: string | undefined;
}

export interface GetUsersRequest {
  Paging?: PagingInfo | undefined;
}

export interface GetUsersResponse {
  Users: User[];
  TotalCount: number;
}

export interface ArchiveUserRequest {
  UserId: string;
}

export interface ArchiveUserResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface UpdateUserRequest {
  User?: User | undefined;
}

export interface UpdateUserResponse {
  Success: boolean;
  Message?: string | undefined;
}

export interface Account {
  Id: string;
  Name: string;
  TaxId?: string | undefined;
  DriveStorageLimits?: StorageLimits | undefined;
}

export interface User {
  Id: string;
  Name: string;
  EmailAddress: string;
  Phone?: string | undefined;
  Source?: string | undefined;
  Role: UserRoles;
  DateEmailConfirmed?: Date | undefined;
  DatePhoneConfirmed?: Date | undefined;
  AllowedToLogin: boolean;
  AllowSMS: boolean;
  AllowEmail: boolean;
  EmailLists: EmailList[];
  Status: UserStatus;
}

export interface EmailList {
  Id: string;
  Name: string;
}

/** Admin messages */
export interface AdminGetAccountsRequest {
  Paging?: PagingInfo | undefined;
}

export interface AdminGetAccountsResponse {
  Accounts: AdminAccountSummary[];
  TotalCount: number;
}

export interface AdminAccountSummary {
  Id: string;
  Name: string;
}

export interface AdminGetAccountRequest {
  AccountId: string;
}

export interface AdminGetAccountResponse {
  Account?: Account | undefined;
  UserCount: number;
  HostCount: number;
  AppCount: number;
  CreditInfo?: CreditAccountInfo | undefined;
}

export interface AdminUpdateAccountRequest {
  AccountId: string;
  Name: string;
}

/** Admin audit messages */
export interface AdminAuditCreditBalanceRequest {
  AccountId: string;
}

export interface AdminAuditCreditBalanceResponse {
  AccountId: string;
  StoredBalance: Long;
  CalculatedBalance: Long;
  StoredTotalEarned: Long;
  CalculatedTotalEarned: Long;
  StoredTotalSpent: Long;
  CalculatedTotalSpent: Long;
  StoredTotalPurchased: Long;
  CalculatedTotalPurchased: Long;
  TransactionCount: number;
  BalanceMatches: boolean;
  WasCorrected: boolean;
  Message?: string | undefined;
}

export interface AdminSetStorageLimitsRequest {
  AccountId: string;
  Limits?: StorageLimits | undefined;
}

/** Admin resource listing messages */
export interface AdminGetAccountUsersRequest {
  AccountId: string;
  Paging?: PagingInfo | undefined;
}

export interface AdminGetAccountUsersResponse {
  Users: User[];
  TotalCount: number;
}

export interface AdminGetAccountHostsRequest {
  AccountId: string;
  Paging?: PagingInfo | undefined;
}

export interface AdminGetAccountHostsResponse {
  Hosts: Host[];
  TotalCount: number;
}

export interface AdminGetAccountAppsRequest {
  AccountId: string;
  Paging?: PagingInfo | undefined;
}

export interface AdminGetAccountAppsResponse {
  Apps: Dapp[];
  TotalCount: number;
}

function createBaseGetAccountRequest(): GetAccountRequest {
  return {};
}

export const GetAccountRequest: MessageFns<GetAccountRequest> = {
  encode(_: GetAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetAccountRequest {
    return {};
  },

  toJSON(_: GetAccountRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAccountRequest>, I>>(base?: I): GetAccountRequest {
    return GetAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAccountRequest>, I>>(_: I): GetAccountRequest {
    const message = createBaseGetAccountRequest();
    return message;
  },
};

function createBaseGetAccountResponse(): GetAccountResponse {
  return { Account: undefined, HasTaxId: false };
}

export const GetAccountResponse: MessageFns<GetAccountResponse> = {
  encode(message: GetAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      Account.encode(message.Account, writer.uint32(10).fork()).join();
    }
    if (message.HasTaxId !== false) {
      writer.uint32(16).bool(message.HasTaxId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = Account.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.HasTaxId = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAccountResponse {
    return {
      Account: isSet(object.Account) ? Account.fromJSON(object.Account) : undefined,
      HasTaxId: isSet(object.HasTaxId) ? globalThis.Boolean(object.HasTaxId) : false,
    };
  },

  toJSON(message: GetAccountResponse): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = Account.toJSON(message.Account);
    }
    if (message.HasTaxId !== false) {
      obj.HasTaxId = message.HasTaxId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAccountResponse>, I>>(base?: I): GetAccountResponse {
    return GetAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAccountResponse>, I>>(object: I): GetAccountResponse {
    const message = createBaseGetAccountResponse();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? Account.fromPartial(object.Account)
      : undefined;
    message.HasTaxId = object.HasTaxId ?? false;
    return message;
  },
};

function createBaseUpdateAccountRequest(): UpdateAccountRequest {
  return { Account: undefined };
}

export const UpdateAccountRequest: MessageFns<UpdateAccountRequest> = {
  encode(message: UpdateAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      Account.encode(message.Account, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = Account.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateAccountRequest {
    return { Account: isSet(object.Account) ? Account.fromJSON(object.Account) : undefined };
  },

  toJSON(message: UpdateAccountRequest): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = Account.toJSON(message.Account);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateAccountRequest>, I>>(base?: I): UpdateAccountRequest {
    return UpdateAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateAccountRequest>, I>>(object: I): UpdateAccountRequest {
    const message = createBaseUpdateAccountRequest();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? Account.fromPartial(object.Account)
      : undefined;
    return message;
  },
};

function createBaseUpdateAccountResponse(): UpdateAccountResponse {
  return { Success: false, Message: undefined };
}

export const UpdateAccountResponse: MessageFns<UpdateAccountResponse> = {
  encode(message: UpdateAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateAccountResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: UpdateAccountResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateAccountResponse>, I>>(base?: I): UpdateAccountResponse {
    return UpdateAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateAccountResponse>, I>>(object: I): UpdateAccountResponse {
    const message = createBaseUpdateAccountResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseCreateUserRequest(): CreateUserRequest {
  return { User: undefined, AccountName: undefined };
}

export const CreateUserRequest: MessageFns<CreateUserRequest> = {
  encode(message: CreateUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.User !== undefined) {
      User.encode(message.User, writer.uint32(10).fork()).join();
    }
    if (message.AccountName !== undefined) {
      writer.uint32(18).string(message.AccountName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.User = User.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateUserRequest {
    return {
      User: isSet(object.User) ? User.fromJSON(object.User) : undefined,
      AccountName: isSet(object.AccountName) ? globalThis.String(object.AccountName) : undefined,
    };
  },

  toJSON(message: CreateUserRequest): unknown {
    const obj: any = {};
    if (message.User !== undefined) {
      obj.User = User.toJSON(message.User);
    }
    if (message.AccountName !== undefined) {
      obj.AccountName = message.AccountName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateUserRequest>, I>>(base?: I): CreateUserRequest {
    return CreateUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateUserRequest>, I>>(object: I): CreateUserRequest {
    const message = createBaseCreateUserRequest();
    message.User = (object.User !== undefined && object.User !== null) ? User.fromPartial(object.User) : undefined;
    message.AccountName = object.AccountName ?? undefined;
    return message;
  },
};

function createBaseCreateUserResponse(): CreateUserResponse {
  return { Success: false, User: undefined, Message: undefined };
}

export const CreateUserResponse: MessageFns<CreateUserResponse> = {
  encode(message: CreateUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.User !== undefined) {
      User.encode(message.User, writer.uint32(18).fork()).join();
    }
    if (message.Message !== undefined) {
      writer.uint32(26).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.User = User.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateUserResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      User: isSet(object.User) ? User.fromJSON(object.User) : undefined,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: CreateUserResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.User !== undefined) {
      obj.User = User.toJSON(message.User);
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateUserResponse>, I>>(base?: I): CreateUserResponse {
    return CreateUserResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateUserResponse>, I>>(object: I): CreateUserResponse {
    const message = createBaseCreateUserResponse();
    message.Success = object.Success ?? false;
    message.User = (object.User !== undefined && object.User !== null) ? User.fromPartial(object.User) : undefined;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseGetUserRequest(): GetUserRequest {
  return { UserId: "" };
}

export const GetUserRequest: MessageFns<GetUserRequest> = {
  encode(message: GetUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.UserId !== "") {
      writer.uint32(10).string(message.UserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.UserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserRequest {
    return { UserId: isSet(object.UserId) ? globalThis.String(object.UserId) : "" };
  },

  toJSON(message: GetUserRequest): unknown {
    const obj: any = {};
    if (message.UserId !== "") {
      obj.UserId = message.UserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUserRequest>, I>>(base?: I): GetUserRequest {
    return GetUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUserRequest>, I>>(object: I): GetUserRequest {
    const message = createBaseGetUserRequest();
    message.UserId = object.UserId ?? "";
    return message;
  },
};

function createBaseGetUserResponse(): GetUserResponse {
  return { User: undefined, Success: false, Message: undefined };
}

export const GetUserResponse: MessageFns<GetUserResponse> = {
  encode(message: GetUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.User !== undefined) {
      User.encode(message.User, writer.uint32(10).fork()).join();
    }
    if (message.Success !== false) {
      writer.uint32(16).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(26).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.User = User.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserResponse {
    return {
      User: isSet(object.User) ? User.fromJSON(object.User) : undefined,
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: GetUserResponse): unknown {
    const obj: any = {};
    if (message.User !== undefined) {
      obj.User = User.toJSON(message.User);
    }
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUserResponse>, I>>(base?: I): GetUserResponse {
    return GetUserResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUserResponse>, I>>(object: I): GetUserResponse {
    const message = createBaseGetUserResponse();
    message.User = (object.User !== undefined && object.User !== null) ? User.fromPartial(object.User) : undefined;
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseGetUsersRequest(): GetUsersRequest {
  return { Paging: undefined };
}

export const GetUsersRequest: MessageFns<GetUsersRequest> = {
  encode(message: GetUsersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUsersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersRequest {
    return { Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined };
  },

  toJSON(message: GetUsersRequest): unknown {
    const obj: any = {};
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersRequest>, I>>(base?: I): GetUsersRequest {
    return GetUsersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersRequest>, I>>(object: I): GetUsersRequest {
    const message = createBaseGetUsersRequest();
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseGetUsersResponse(): GetUsersResponse {
  return { Users: [], TotalCount: 0 };
}

export const GetUsersResponse: MessageFns<GetUsersResponse> = {
  encode(message: GetUsersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Users) {
      User.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUsersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUsersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Users.push(User.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUsersResponse {
    return {
      Users: globalThis.Array.isArray(object?.Users) ? object.Users.map((e: any) => User.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: GetUsersResponse): unknown {
    const obj: any = {};
    if (message.Users?.length) {
      obj.Users = message.Users.map((e) => User.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUsersResponse>, I>>(base?: I): GetUsersResponse {
    return GetUsersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUsersResponse>, I>>(object: I): GetUsersResponse {
    const message = createBaseGetUsersResponse();
    message.Users = object.Users?.map((e) => User.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseArchiveUserRequest(): ArchiveUserRequest {
  return { UserId: "" };
}

export const ArchiveUserRequest: MessageFns<ArchiveUserRequest> = {
  encode(message: ArchiveUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.UserId !== "") {
      writer.uint32(10).string(message.UserId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.UserId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveUserRequest {
    return { UserId: isSet(object.UserId) ? globalThis.String(object.UserId) : "" };
  },

  toJSON(message: ArchiveUserRequest): unknown {
    const obj: any = {};
    if (message.UserId !== "") {
      obj.UserId = message.UserId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveUserRequest>, I>>(base?: I): ArchiveUserRequest {
    return ArchiveUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveUserRequest>, I>>(object: I): ArchiveUserRequest {
    const message = createBaseArchiveUserRequest();
    message.UserId = object.UserId ?? "";
    return message;
  },
};

function createBaseArchiveUserResponse(): ArchiveUserResponse {
  return { Success: false, Message: undefined };
}

export const ArchiveUserResponse: MessageFns<ArchiveUserResponse> = {
  encode(message: ArchiveUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveUserResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: ArchiveUserResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArchiveUserResponse>, I>>(base?: I): ArchiveUserResponse {
    return ArchiveUserResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArchiveUserResponse>, I>>(object: I): ArchiveUserResponse {
    const message = createBaseArchiveUserResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseUpdateUserRequest(): UpdateUserRequest {
  return { User: undefined };
}

export const UpdateUserRequest: MessageFns<UpdateUserRequest> = {
  encode(message: UpdateUserRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.User !== undefined) {
      User.encode(message.User, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.User = User.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserRequest {
    return { User: isSet(object.User) ? User.fromJSON(object.User) : undefined };
  },

  toJSON(message: UpdateUserRequest): unknown {
    const obj: any = {};
    if (message.User !== undefined) {
      obj.User = User.toJSON(message.User);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateUserRequest>, I>>(base?: I): UpdateUserRequest {
    return UpdateUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateUserRequest>, I>>(object: I): UpdateUserRequest {
    const message = createBaseUpdateUserRequest();
    message.User = (object.User !== undefined && object.User !== null) ? User.fromPartial(object.User) : undefined;
    return message;
  },
};

function createBaseUpdateUserResponse(): UpdateUserResponse {
  return { Success: false, Message: undefined };
}

export const UpdateUserResponse: MessageFns<UpdateUserResponse> = {
  encode(message: UpdateUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Message !== undefined) {
      writer.uint32(18).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: UpdateUserResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateUserResponse>, I>>(base?: I): UpdateUserResponse {
    return UpdateUserResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateUserResponse>, I>>(object: I): UpdateUserResponse {
    const message = createBaseUpdateUserResponse();
    message.Success = object.Success ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseAccount(): Account {
  return { Id: "", Name: "", TaxId: undefined, DriveStorageLimits: undefined };
}

export const Account: MessageFns<Account> = {
  encode(message: Account, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.TaxId !== undefined) {
      writer.uint32(26).string(message.TaxId);
    }
    if (message.DriveStorageLimits !== undefined) {
      StorageLimits.encode(message.DriveStorageLimits, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Account {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccount();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.TaxId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.DriveStorageLimits = StorageLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Account {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      TaxId: isSet(object.TaxId) ? globalThis.String(object.TaxId) : undefined,
      DriveStorageLimits: isSet(object.DriveStorageLimits)
        ? StorageLimits.fromJSON(object.DriveStorageLimits)
        : undefined,
    };
  },

  toJSON(message: Account): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.TaxId !== undefined) {
      obj.TaxId = message.TaxId;
    }
    if (message.DriveStorageLimits !== undefined) {
      obj.DriveStorageLimits = StorageLimits.toJSON(message.DriveStorageLimits);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Account>, I>>(base?: I): Account {
    return Account.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Account>, I>>(object: I): Account {
    const message = createBaseAccount();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.TaxId = object.TaxId ?? undefined;
    message.DriveStorageLimits = (object.DriveStorageLimits !== undefined && object.DriveStorageLimits !== null)
      ? StorageLimits.fromPartial(object.DriveStorageLimits)
      : undefined;
    return message;
  },
};

function createBaseUser(): User {
  return {
    Id: "",
    Name: "",
    EmailAddress: "",
    Phone: undefined,
    Source: undefined,
    Role: 0,
    DateEmailConfirmed: undefined,
    DatePhoneConfirmed: undefined,
    AllowedToLogin: false,
    AllowSMS: false,
    AllowEmail: false,
    EmailLists: [],
    Status: 0,
  };
}

export const User: MessageFns<User> = {
  encode(message: User, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.EmailAddress !== "") {
      writer.uint32(26).string(message.EmailAddress);
    }
    if (message.Phone !== undefined) {
      writer.uint32(34).string(message.Phone);
    }
    if (message.Source !== undefined) {
      writer.uint32(42).string(message.Source);
    }
    if (message.Role !== 0) {
      writer.uint32(48).int32(message.Role);
    }
    if (message.DateEmailConfirmed !== undefined) {
      Timestamp.encode(toTimestamp(message.DateEmailConfirmed), writer.uint32(58).fork()).join();
    }
    if (message.DatePhoneConfirmed !== undefined) {
      Timestamp.encode(toTimestamp(message.DatePhoneConfirmed), writer.uint32(66).fork()).join();
    }
    if (message.AllowedToLogin !== false) {
      writer.uint32(72).bool(message.AllowedToLogin);
    }
    if (message.AllowSMS !== false) {
      writer.uint32(80).bool(message.AllowSMS);
    }
    if (message.AllowEmail !== false) {
      writer.uint32(88).bool(message.AllowEmail);
    }
    for (const v of message.EmailLists) {
      EmailList.encode(v!, writer.uint32(98).fork()).join();
    }
    if (message.Status !== 0) {
      writer.uint32(104).int32(message.Status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): User {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUser();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.EmailAddress = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Phone = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.Source = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.Role = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.DateEmailConfirmed = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DatePhoneConfirmed = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.AllowedToLogin = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.AllowSMS = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.AllowEmail = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.EmailLists.push(EmailList.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.Status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): User {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      EmailAddress: isSet(object.EmailAddress) ? globalThis.String(object.EmailAddress) : "",
      Phone: isSet(object.Phone) ? globalThis.String(object.Phone) : undefined,
      Source: isSet(object.Source) ? globalThis.String(object.Source) : undefined,
      Role: isSet(object.Role) ? userRolesFromJSON(object.Role) : 0,
      DateEmailConfirmed: isSet(object.DateEmailConfirmed) ? fromJsonTimestamp(object.DateEmailConfirmed) : undefined,
      DatePhoneConfirmed: isSet(object.DatePhoneConfirmed) ? fromJsonTimestamp(object.DatePhoneConfirmed) : undefined,
      AllowedToLogin: isSet(object.AllowedToLogin) ? globalThis.Boolean(object.AllowedToLogin) : false,
      AllowSMS: isSet(object.AllowSMS) ? globalThis.Boolean(object.AllowSMS) : false,
      AllowEmail: isSet(object.AllowEmail) ? globalThis.Boolean(object.AllowEmail) : false,
      EmailLists: globalThis.Array.isArray(object?.EmailLists)
        ? object.EmailLists.map((e: any) => EmailList.fromJSON(e))
        : [],
      Status: isSet(object.Status) ? userStatusFromJSON(object.Status) : 0,
    };
  },

  toJSON(message: User): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.EmailAddress !== "") {
      obj.EmailAddress = message.EmailAddress;
    }
    if (message.Phone !== undefined) {
      obj.Phone = message.Phone;
    }
    if (message.Source !== undefined) {
      obj.Source = message.Source;
    }
    if (message.Role !== 0) {
      obj.Role = userRolesToJSON(message.Role);
    }
    if (message.DateEmailConfirmed !== undefined) {
      obj.DateEmailConfirmed = message.DateEmailConfirmed.toISOString();
    }
    if (message.DatePhoneConfirmed !== undefined) {
      obj.DatePhoneConfirmed = message.DatePhoneConfirmed.toISOString();
    }
    if (message.AllowedToLogin !== false) {
      obj.AllowedToLogin = message.AllowedToLogin;
    }
    if (message.AllowSMS !== false) {
      obj.AllowSMS = message.AllowSMS;
    }
    if (message.AllowEmail !== false) {
      obj.AllowEmail = message.AllowEmail;
    }
    if (message.EmailLists?.length) {
      obj.EmailLists = message.EmailLists.map((e) => EmailList.toJSON(e));
    }
    if (message.Status !== 0) {
      obj.Status = userStatusToJSON(message.Status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<User>, I>>(base?: I): User {
    return User.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<User>, I>>(object: I): User {
    const message = createBaseUser();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    message.EmailAddress = object.EmailAddress ?? "";
    message.Phone = object.Phone ?? undefined;
    message.Source = object.Source ?? undefined;
    message.Role = object.Role ?? 0;
    message.DateEmailConfirmed = object.DateEmailConfirmed ?? undefined;
    message.DatePhoneConfirmed = object.DatePhoneConfirmed ?? undefined;
    message.AllowedToLogin = object.AllowedToLogin ?? false;
    message.AllowSMS = object.AllowSMS ?? false;
    message.AllowEmail = object.AllowEmail ?? false;
    message.EmailLists = object.EmailLists?.map((e) => EmailList.fromPartial(e)) || [];
    message.Status = object.Status ?? 0;
    return message;
  },
};

function createBaseEmailList(): EmailList {
  return { Id: "", Name: "" };
}

export const EmailList: MessageFns<EmailList> = {
  encode(message: EmailList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EmailList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmailList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EmailList {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
    };
  },

  toJSON(message: EmailList): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EmailList>, I>>(base?: I): EmailList {
    return EmailList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EmailList>, I>>(object: I): EmailList {
    const message = createBaseEmailList();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    return message;
  },
};

function createBaseAdminGetAccountsRequest(): AdminGetAccountsRequest {
  return { Paging: undefined };
}

export const AdminGetAccountsRequest: MessageFns<AdminGetAccountsRequest> = {
  encode(message: AdminGetAccountsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountsRequest {
    return { Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined };
  },

  toJSON(message: AdminGetAccountsRequest): unknown {
    const obj: any = {};
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountsRequest>, I>>(base?: I): AdminGetAccountsRequest {
    return AdminGetAccountsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountsRequest>, I>>(object: I): AdminGetAccountsRequest {
    const message = createBaseAdminGetAccountsRequest();
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseAdminGetAccountsResponse(): AdminGetAccountsResponse {
  return { Accounts: [], TotalCount: 0 };
}

export const AdminGetAccountsResponse: MessageFns<AdminGetAccountsResponse> = {
  encode(message: AdminGetAccountsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Accounts) {
      AdminAccountSummary.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Accounts.push(AdminAccountSummary.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountsResponse {
    return {
      Accounts: globalThis.Array.isArray(object?.Accounts)
        ? object.Accounts.map((e: any) => AdminAccountSummary.fromJSON(e))
        : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: AdminGetAccountsResponse): unknown {
    const obj: any = {};
    if (message.Accounts?.length) {
      obj.Accounts = message.Accounts.map((e) => AdminAccountSummary.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountsResponse>, I>>(base?: I): AdminGetAccountsResponse {
    return AdminGetAccountsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountsResponse>, I>>(object: I): AdminGetAccountsResponse {
    const message = createBaseAdminGetAccountsResponse();
    message.Accounts = object.Accounts?.map((e) => AdminAccountSummary.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseAdminAccountSummary(): AdminAccountSummary {
  return { Id: "", Name: "" };
}

export const AdminAccountSummary: MessageFns<AdminAccountSummary> = {
  encode(message: AdminAccountSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminAccountSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminAccountSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminAccountSummary {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
    };
  },

  toJSON(message: AdminAccountSummary): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminAccountSummary>, I>>(base?: I): AdminAccountSummary {
    return AdminAccountSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminAccountSummary>, I>>(object: I): AdminAccountSummary {
    const message = createBaseAdminAccountSummary();
    message.Id = object.Id ?? "";
    message.Name = object.Name ?? "";
    return message;
  },
};

function createBaseAdminGetAccountRequest(): AdminGetAccountRequest {
  return { AccountId: "" };
}

export const AdminGetAccountRequest: MessageFns<AdminGetAccountRequest> = {
  encode(message: AdminGetAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: AdminGetAccountRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountRequest>, I>>(base?: I): AdminGetAccountRequest {
    return AdminGetAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountRequest>, I>>(object: I): AdminGetAccountRequest {
    const message = createBaseAdminGetAccountRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseAdminGetAccountResponse(): AdminGetAccountResponse {
  return { Account: undefined, UserCount: 0, HostCount: 0, AppCount: 0, CreditInfo: undefined };
}

export const AdminGetAccountResponse: MessageFns<AdminGetAccountResponse> = {
  encode(message: AdminGetAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      Account.encode(message.Account, writer.uint32(10).fork()).join();
    }
    if (message.UserCount !== 0) {
      writer.uint32(16).int32(message.UserCount);
    }
    if (message.HostCount !== 0) {
      writer.uint32(24).int32(message.HostCount);
    }
    if (message.AppCount !== 0) {
      writer.uint32(32).int32(message.AppCount);
    }
    if (message.CreditInfo !== undefined) {
      CreditAccountInfo.encode(message.CreditInfo, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = Account.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.UserCount = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.HostCount = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.AppCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.CreditInfo = CreditAccountInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountResponse {
    return {
      Account: isSet(object.Account) ? Account.fromJSON(object.Account) : undefined,
      UserCount: isSet(object.UserCount) ? globalThis.Number(object.UserCount) : 0,
      HostCount: isSet(object.HostCount) ? globalThis.Number(object.HostCount) : 0,
      AppCount: isSet(object.AppCount) ? globalThis.Number(object.AppCount) : 0,
      CreditInfo: isSet(object.CreditInfo) ? CreditAccountInfo.fromJSON(object.CreditInfo) : undefined,
    };
  },

  toJSON(message: AdminGetAccountResponse): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = Account.toJSON(message.Account);
    }
    if (message.UserCount !== 0) {
      obj.UserCount = Math.round(message.UserCount);
    }
    if (message.HostCount !== 0) {
      obj.HostCount = Math.round(message.HostCount);
    }
    if (message.AppCount !== 0) {
      obj.AppCount = Math.round(message.AppCount);
    }
    if (message.CreditInfo !== undefined) {
      obj.CreditInfo = CreditAccountInfo.toJSON(message.CreditInfo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountResponse>, I>>(base?: I): AdminGetAccountResponse {
    return AdminGetAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountResponse>, I>>(object: I): AdminGetAccountResponse {
    const message = createBaseAdminGetAccountResponse();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? Account.fromPartial(object.Account)
      : undefined;
    message.UserCount = object.UserCount ?? 0;
    message.HostCount = object.HostCount ?? 0;
    message.AppCount = object.AppCount ?? 0;
    message.CreditInfo = (object.CreditInfo !== undefined && object.CreditInfo !== null)
      ? CreditAccountInfo.fromPartial(object.CreditInfo)
      : undefined;
    return message;
  },
};

function createBaseAdminUpdateAccountRequest(): AdminUpdateAccountRequest {
  return { AccountId: "", Name: "" };
}

export const AdminUpdateAccountRequest: MessageFns<AdminUpdateAccountRequest> = {
  encode(message: AdminUpdateAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminUpdateAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminUpdateAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminUpdateAccountRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
    };
  },

  toJSON(message: AdminUpdateAccountRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminUpdateAccountRequest>, I>>(base?: I): AdminUpdateAccountRequest {
    return AdminUpdateAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminUpdateAccountRequest>, I>>(object: I): AdminUpdateAccountRequest {
    const message = createBaseAdminUpdateAccountRequest();
    message.AccountId = object.AccountId ?? "";
    message.Name = object.Name ?? "";
    return message;
  },
};

function createBaseAdminAuditCreditBalanceRequest(): AdminAuditCreditBalanceRequest {
  return { AccountId: "" };
}

export const AdminAuditCreditBalanceRequest: MessageFns<AdminAuditCreditBalanceRequest> = {
  encode(message: AdminAuditCreditBalanceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminAuditCreditBalanceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminAuditCreditBalanceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminAuditCreditBalanceRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: AdminAuditCreditBalanceRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminAuditCreditBalanceRequest>, I>>(base?: I): AdminAuditCreditBalanceRequest {
    return AdminAuditCreditBalanceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminAuditCreditBalanceRequest>, I>>(
    object: I,
  ): AdminAuditCreditBalanceRequest {
    const message = createBaseAdminAuditCreditBalanceRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseAdminAuditCreditBalanceResponse(): AdminAuditCreditBalanceResponse {
  return {
    AccountId: "",
    StoredBalance: Long.ZERO,
    CalculatedBalance: Long.ZERO,
    StoredTotalEarned: Long.ZERO,
    CalculatedTotalEarned: Long.ZERO,
    StoredTotalSpent: Long.ZERO,
    CalculatedTotalSpent: Long.ZERO,
    StoredTotalPurchased: Long.ZERO,
    CalculatedTotalPurchased: Long.ZERO,
    TransactionCount: 0,
    BalanceMatches: false,
    WasCorrected: false,
    Message: undefined,
  };
}

export const AdminAuditCreditBalanceResponse: MessageFns<AdminAuditCreditBalanceResponse> = {
  encode(message: AdminAuditCreditBalanceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (!message.StoredBalance.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.StoredBalance.toString());
    }
    if (!message.CalculatedBalance.equals(Long.ZERO)) {
      writer.uint32(24).int64(message.CalculatedBalance.toString());
    }
    if (!message.StoredTotalEarned.equals(Long.ZERO)) {
      writer.uint32(32).int64(message.StoredTotalEarned.toString());
    }
    if (!message.CalculatedTotalEarned.equals(Long.ZERO)) {
      writer.uint32(40).int64(message.CalculatedTotalEarned.toString());
    }
    if (!message.StoredTotalSpent.equals(Long.ZERO)) {
      writer.uint32(48).int64(message.StoredTotalSpent.toString());
    }
    if (!message.CalculatedTotalSpent.equals(Long.ZERO)) {
      writer.uint32(56).int64(message.CalculatedTotalSpent.toString());
    }
    if (!message.StoredTotalPurchased.equals(Long.ZERO)) {
      writer.uint32(64).int64(message.StoredTotalPurchased.toString());
    }
    if (!message.CalculatedTotalPurchased.equals(Long.ZERO)) {
      writer.uint32(72).int64(message.CalculatedTotalPurchased.toString());
    }
    if (message.TransactionCount !== 0) {
      writer.uint32(80).int32(message.TransactionCount);
    }
    if (message.BalanceMatches !== false) {
      writer.uint32(88).bool(message.BalanceMatches);
    }
    if (message.WasCorrected !== false) {
      writer.uint32(96).bool(message.WasCorrected);
    }
    if (message.Message !== undefined) {
      writer.uint32(106).string(message.Message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminAuditCreditBalanceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminAuditCreditBalanceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.StoredBalance = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.CalculatedBalance = Long.fromString(reader.int64().toString());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.StoredTotalEarned = Long.fromString(reader.int64().toString());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.CalculatedTotalEarned = Long.fromString(reader.int64().toString());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.StoredTotalSpent = Long.fromString(reader.int64().toString());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.CalculatedTotalSpent = Long.fromString(reader.int64().toString());
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.StoredTotalPurchased = Long.fromString(reader.int64().toString());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.CalculatedTotalPurchased = Long.fromString(reader.int64().toString());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.TransactionCount = reader.int32();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.BalanceMatches = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.WasCorrected = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.Message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminAuditCreditBalanceResponse {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      StoredBalance: isSet(object.StoredBalance) ? Long.fromValue(object.StoredBalance) : Long.ZERO,
      CalculatedBalance: isSet(object.CalculatedBalance) ? Long.fromValue(object.CalculatedBalance) : Long.ZERO,
      StoredTotalEarned: isSet(object.StoredTotalEarned) ? Long.fromValue(object.StoredTotalEarned) : Long.ZERO,
      CalculatedTotalEarned: isSet(object.CalculatedTotalEarned)
        ? Long.fromValue(object.CalculatedTotalEarned)
        : Long.ZERO,
      StoredTotalSpent: isSet(object.StoredTotalSpent) ? Long.fromValue(object.StoredTotalSpent) : Long.ZERO,
      CalculatedTotalSpent: isSet(object.CalculatedTotalSpent)
        ? Long.fromValue(object.CalculatedTotalSpent)
        : Long.ZERO,
      StoredTotalPurchased: isSet(object.StoredTotalPurchased)
        ? Long.fromValue(object.StoredTotalPurchased)
        : Long.ZERO,
      CalculatedTotalPurchased: isSet(object.CalculatedTotalPurchased)
        ? Long.fromValue(object.CalculatedTotalPurchased)
        : Long.ZERO,
      TransactionCount: isSet(object.TransactionCount) ? globalThis.Number(object.TransactionCount) : 0,
      BalanceMatches: isSet(object.BalanceMatches) ? globalThis.Boolean(object.BalanceMatches) : false,
      WasCorrected: isSet(object.WasCorrected) ? globalThis.Boolean(object.WasCorrected) : false,
      Message: isSet(object.Message) ? globalThis.String(object.Message) : undefined,
    };
  },

  toJSON(message: AdminAuditCreditBalanceResponse): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (!message.StoredBalance.equals(Long.ZERO)) {
      obj.StoredBalance = (message.StoredBalance || Long.ZERO).toString();
    }
    if (!message.CalculatedBalance.equals(Long.ZERO)) {
      obj.CalculatedBalance = (message.CalculatedBalance || Long.ZERO).toString();
    }
    if (!message.StoredTotalEarned.equals(Long.ZERO)) {
      obj.StoredTotalEarned = (message.StoredTotalEarned || Long.ZERO).toString();
    }
    if (!message.CalculatedTotalEarned.equals(Long.ZERO)) {
      obj.CalculatedTotalEarned = (message.CalculatedTotalEarned || Long.ZERO).toString();
    }
    if (!message.StoredTotalSpent.equals(Long.ZERO)) {
      obj.StoredTotalSpent = (message.StoredTotalSpent || Long.ZERO).toString();
    }
    if (!message.CalculatedTotalSpent.equals(Long.ZERO)) {
      obj.CalculatedTotalSpent = (message.CalculatedTotalSpent || Long.ZERO).toString();
    }
    if (!message.StoredTotalPurchased.equals(Long.ZERO)) {
      obj.StoredTotalPurchased = (message.StoredTotalPurchased || Long.ZERO).toString();
    }
    if (!message.CalculatedTotalPurchased.equals(Long.ZERO)) {
      obj.CalculatedTotalPurchased = (message.CalculatedTotalPurchased || Long.ZERO).toString();
    }
    if (message.TransactionCount !== 0) {
      obj.TransactionCount = Math.round(message.TransactionCount);
    }
    if (message.BalanceMatches !== false) {
      obj.BalanceMatches = message.BalanceMatches;
    }
    if (message.WasCorrected !== false) {
      obj.WasCorrected = message.WasCorrected;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminAuditCreditBalanceResponse>, I>>(base?: I): AdminAuditCreditBalanceResponse {
    return AdminAuditCreditBalanceResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminAuditCreditBalanceResponse>, I>>(
    object: I,
  ): AdminAuditCreditBalanceResponse {
    const message = createBaseAdminAuditCreditBalanceResponse();
    message.AccountId = object.AccountId ?? "";
    message.StoredBalance = (object.StoredBalance !== undefined && object.StoredBalance !== null)
      ? Long.fromValue(object.StoredBalance)
      : Long.ZERO;
    message.CalculatedBalance = (object.CalculatedBalance !== undefined && object.CalculatedBalance !== null)
      ? Long.fromValue(object.CalculatedBalance)
      : Long.ZERO;
    message.StoredTotalEarned = (object.StoredTotalEarned !== undefined && object.StoredTotalEarned !== null)
      ? Long.fromValue(object.StoredTotalEarned)
      : Long.ZERO;
    message.CalculatedTotalEarned =
      (object.CalculatedTotalEarned !== undefined && object.CalculatedTotalEarned !== null)
        ? Long.fromValue(object.CalculatedTotalEarned)
        : Long.ZERO;
    message.StoredTotalSpent = (object.StoredTotalSpent !== undefined && object.StoredTotalSpent !== null)
      ? Long.fromValue(object.StoredTotalSpent)
      : Long.ZERO;
    message.CalculatedTotalSpent = (object.CalculatedTotalSpent !== undefined && object.CalculatedTotalSpent !== null)
      ? Long.fromValue(object.CalculatedTotalSpent)
      : Long.ZERO;
    message.StoredTotalPurchased = (object.StoredTotalPurchased !== undefined && object.StoredTotalPurchased !== null)
      ? Long.fromValue(object.StoredTotalPurchased)
      : Long.ZERO;
    message.CalculatedTotalPurchased =
      (object.CalculatedTotalPurchased !== undefined && object.CalculatedTotalPurchased !== null)
        ? Long.fromValue(object.CalculatedTotalPurchased)
        : Long.ZERO;
    message.TransactionCount = object.TransactionCount ?? 0;
    message.BalanceMatches = object.BalanceMatches ?? false;
    message.WasCorrected = object.WasCorrected ?? false;
    message.Message = object.Message ?? undefined;
    return message;
  },
};

function createBaseAdminSetStorageLimitsRequest(): AdminSetStorageLimitsRequest {
  return { AccountId: "", Limits: undefined };
}

export const AdminSetStorageLimitsRequest: MessageFns<AdminSetStorageLimitsRequest> = {
  encode(message: AdminSetStorageLimitsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Limits !== undefined) {
      StorageLimits.encode(message.Limits, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminSetStorageLimitsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminSetStorageLimitsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Limits = StorageLimits.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminSetStorageLimitsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Limits: isSet(object.Limits) ? StorageLimits.fromJSON(object.Limits) : undefined,
    };
  },

  toJSON(message: AdminSetStorageLimitsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Limits !== undefined) {
      obj.Limits = StorageLimits.toJSON(message.Limits);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminSetStorageLimitsRequest>, I>>(base?: I): AdminSetStorageLimitsRequest {
    return AdminSetStorageLimitsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminSetStorageLimitsRequest>, I>>(object: I): AdminSetStorageLimitsRequest {
    const message = createBaseAdminSetStorageLimitsRequest();
    message.AccountId = object.AccountId ?? "";
    message.Limits = (object.Limits !== undefined && object.Limits !== null)
      ? StorageLimits.fromPartial(object.Limits)
      : undefined;
    return message;
  },
};

function createBaseAdminGetAccountUsersRequest(): AdminGetAccountUsersRequest {
  return { AccountId: "", Paging: undefined };
}

export const AdminGetAccountUsersRequest: MessageFns<AdminGetAccountUsersRequest> = {
  encode(message: AdminGetAccountUsersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountUsersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountUsersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountUsersRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined,
    };
  },

  toJSON(message: AdminGetAccountUsersRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountUsersRequest>, I>>(base?: I): AdminGetAccountUsersRequest {
    return AdminGetAccountUsersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountUsersRequest>, I>>(object: I): AdminGetAccountUsersRequest {
    const message = createBaseAdminGetAccountUsersRequest();
    message.AccountId = object.AccountId ?? "";
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseAdminGetAccountUsersResponse(): AdminGetAccountUsersResponse {
  return { Users: [], TotalCount: 0 };
}

export const AdminGetAccountUsersResponse: MessageFns<AdminGetAccountUsersResponse> = {
  encode(message: AdminGetAccountUsersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Users) {
      User.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountUsersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountUsersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Users.push(User.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountUsersResponse {
    return {
      Users: globalThis.Array.isArray(object?.Users) ? object.Users.map((e: any) => User.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: AdminGetAccountUsersResponse): unknown {
    const obj: any = {};
    if (message.Users?.length) {
      obj.Users = message.Users.map((e) => User.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountUsersResponse>, I>>(base?: I): AdminGetAccountUsersResponse {
    return AdminGetAccountUsersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountUsersResponse>, I>>(object: I): AdminGetAccountUsersResponse {
    const message = createBaseAdminGetAccountUsersResponse();
    message.Users = object.Users?.map((e) => User.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseAdminGetAccountHostsRequest(): AdminGetAccountHostsRequest {
  return { AccountId: "", Paging: undefined };
}

export const AdminGetAccountHostsRequest: MessageFns<AdminGetAccountHostsRequest> = {
  encode(message: AdminGetAccountHostsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountHostsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountHostsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountHostsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined,
    };
  },

  toJSON(message: AdminGetAccountHostsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountHostsRequest>, I>>(base?: I): AdminGetAccountHostsRequest {
    return AdminGetAccountHostsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountHostsRequest>, I>>(object: I): AdminGetAccountHostsRequest {
    const message = createBaseAdminGetAccountHostsRequest();
    message.AccountId = object.AccountId ?? "";
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseAdminGetAccountHostsResponse(): AdminGetAccountHostsResponse {
  return { Hosts: [], TotalCount: 0 };
}

export const AdminGetAccountHostsResponse: MessageFns<AdminGetAccountHostsResponse> = {
  encode(message: AdminGetAccountHostsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Hosts) {
      Host.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountHostsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountHostsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Hosts.push(Host.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountHostsResponse {
    return {
      Hosts: globalThis.Array.isArray(object?.Hosts) ? object.Hosts.map((e: any) => Host.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: AdminGetAccountHostsResponse): unknown {
    const obj: any = {};
    if (message.Hosts?.length) {
      obj.Hosts = message.Hosts.map((e) => Host.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountHostsResponse>, I>>(base?: I): AdminGetAccountHostsResponse {
    return AdminGetAccountHostsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountHostsResponse>, I>>(object: I): AdminGetAccountHostsResponse {
    const message = createBaseAdminGetAccountHostsResponse();
    message.Hosts = object.Hosts?.map((e) => Host.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseAdminGetAccountAppsRequest(): AdminGetAccountAppsRequest {
  return { AccountId: "", Paging: undefined };
}

export const AdminGetAccountAppsRequest: MessageFns<AdminGetAccountAppsRequest> = {
  encode(message: AdminGetAccountAppsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.Paging !== undefined) {
      PagingInfo.encode(message.Paging, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountAppsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountAppsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Paging = PagingInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountAppsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Paging: isSet(object.Paging) ? PagingInfo.fromJSON(object.Paging) : undefined,
    };
  },

  toJSON(message: AdminGetAccountAppsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Paging !== undefined) {
      obj.Paging = PagingInfo.toJSON(message.Paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountAppsRequest>, I>>(base?: I): AdminGetAccountAppsRequest {
    return AdminGetAccountAppsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountAppsRequest>, I>>(object: I): AdminGetAccountAppsRequest {
    const message = createBaseAdminGetAccountAppsRequest();
    message.AccountId = object.AccountId ?? "";
    message.Paging = (object.Paging !== undefined && object.Paging !== null)
      ? PagingInfo.fromPartial(object.Paging)
      : undefined;
    return message;
  },
};

function createBaseAdminGetAccountAppsResponse(): AdminGetAccountAppsResponse {
  return { Apps: [], TotalCount: 0 };
}

export const AdminGetAccountAppsResponse: MessageFns<AdminGetAccountAppsResponse> = {
  encode(message: AdminGetAccountAppsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Apps) {
      Dapp.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdminGetAccountAppsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdminGetAccountAppsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Apps.push(Dapp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdminGetAccountAppsResponse {
    return {
      Apps: globalThis.Array.isArray(object?.Apps) ? object.Apps.map((e: any) => Dapp.fromJSON(e)) : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: AdminGetAccountAppsResponse): unknown {
    const obj: any = {};
    if (message.Apps?.length) {
      obj.Apps = message.Apps.map((e) => Dapp.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdminGetAccountAppsResponse>, I>>(base?: I): AdminGetAccountAppsResponse {
    return AdminGetAccountAppsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdminGetAccountAppsResponse>, I>>(object: I): AdminGetAccountAppsResponse {
    const message = createBaseAdminGetAccountAppsResponse();
    message.Apps = object.Apps?.map((e) => Dapp.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
